import { transferRegistrationService } from 'src/modules/Distances/services';

export const loadTransferRegistrationData = async (distanceId: number, callBack: Function) => {
  await transferRegistrationService.load(distanceId, callBack);
};
